import {useTranslation} from "react-i18next";
import styles from "./PilotSkill.module.css"
import {skillsKo, skillsEn} from "./skills.js"

const PilotSkill = (props) => {

    const {t} = useTranslation();

    const {serverTime, revealTime, language} = props;

    if(serverTime.isBefore(revealTime)){
        return null;
    }

    const skills = language.includes("ko") ? skillsKo : skillsEn;


    return (
        <div className={styles["pilot-skill"]}>
            <div className={styles["tab-intro"]}>
                <div className={styles["tab-text"]}>
                    <div className={styles["tab-title"]}>
                        {
                            t("PILOT_SKILL")
                        }
                    </div>
                    <div className={styles["tab-desc"]}>
                        {
                            t("PILOT_SKILL_DESC_2")
                        }
                    </div>
                </div>
            </div>



            <section className={styles["skill-list"]}>
                <div className={styles["skill-list-header"]}>
                    <div className={`${styles["skill-list-header-item"]} ${styles.name}`}>
                        {
                            t("SKILL_NAME")
                        }
                    </div>
                    <div className={`${styles["skill-list-header-item"]} ${styles.effect}`}>
                        {
                            t("SKILL_EFFECT")
                        }
                    </div>
                    <div className={`${styles["skill-list-header-item"]} ${styles.range}`}>
                        {
                            t("VALUE_RANGE")
                        }
                    </div>
                </div>


                {
                    skills.map((skill, index) => (
                        <div className={styles["skill-list-row"]} key={index}>
                            <div className={`${styles["skill-list-row-item"]} ${styles.name}`}>
                                {skill.name}
                            </div>

                            <div className={styles["separator"]}/>

                            <div className={`${styles["skill-list-row-item"]} ${styles.effect}`}>
                                {skill.effect}
                            </div>

                            <div className={styles["separator"]}/>

                            <div className={`${styles["skill-list-row-item"]} ${styles.range}`}>
                                {skill.range}
                            </div>
                        </div>
                    ))
                }


            </section>


            <div className={styles["bottom-glow-container"]}>
                <div className={styles.glow1}/>
                <div className={styles.glow2}/>
                <div className={styles.glow3}/>
                <div className={styles.glow4}/>
            </div>

        </div>




    )
}

export default PilotSkill;